import React, { useState } from 'react';
import { Card } from "react-bootstrap";
import { Input,Button } from 'antd';

import { PlusOutlined } from '@ant-design/icons';

const { Search } = Input;

export function AudienceFilter({handelSearch,loading,handleCreateNew}) {    

  return(
    <Card border='light'>
      <Card.Body>        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>          
          <Search
            placeholder="Busca audiencia"
            onSearch={handelSearch}
            enterButton
            style={{ width: 280 }}
            loading={loading}
          />          
          <Button 
            type="primary" 
            icon={<PlusOutlined />} 
            iconPosition="start"
            onClick={handleCreateNew}
          >
            Crear
          </Button>
        </div>
      </Card.Body>
    </Card>
  )
}